module.exports = __webpack_public_path__ + "static/media/YF32_0.be848711.jpg";